import { useConfig } from '../../config.js';

// "What they carry" taxonomy. The server's near_taxonomy config (seeded
// from DEFAULT_NEAR_TAXONOMY, admin-editable) is the source of truth and
// arrives via /api/config; this copy is the first-paint fallback. Keys
// are stable identifiers stored in places.capabilities — labels and
// grouping are presentation and safe to change server-side.
export const DEFAULT_NEAR_TAXONOMY = {
  labels: {
    saltwater: 'Saltwater fish',
    soft_coral: 'Soft coral',
    lps: 'LPS coral',
    premium_sps: 'SPS coral',
    inverts: 'Inverts & CUC',
    live_rock: 'Live rock',
    freshwater: 'Freshwater fish',
    plants: 'Aquatic plants',
    fw_inverts: 'Shrimp & snails',
    saltwater_fill: 'Pre-mixed saltwater',
    rodi_fill: 'RO/DI water',
    water_testing: 'Water testing',
    quarantined_fish: 'Quarantined fish',
    dry_goods: 'Dry goods & gear',
    fish_food: 'Fish food',
  },
  groups: [
    {
      label: 'Saltwater',
      keys: ['saltwater', 'soft_coral', 'lps', 'premium_sps', 'inverts', 'live_rock'],
    },
    { label: 'Freshwater', keys: ['freshwater', 'plants', 'fw_inverts'] },
    {
      label: 'Water & services',
      keys: ['saltwater_fill', 'rodi_fill', 'water_testing', 'quarantined_fish'],
    },
    { label: 'Goods', keys: ['dry_goods', 'fish_food'] },
  ],
};

// A stored taxonomy is used only when it has both halves: one saved
// without `groups` made "+ Store" throw for every keeper.
export function pickNearTaxonomy(t) {
  return t && t.labels && Object.keys(t.labels).length && Array.isArray(t.groups)
    ? t
    : DEFAULT_NEAR_TAXONOMY;
}

export function useNearTaxonomy() {
  return pickNearTaxonomy(useConfig()?.near_taxonomy);
}
